import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const StyledDatePicker = styled(DatePicker)`
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-width: 200px;
	min-height: 34px;
	padding-left: 10px;
	padding-right: 10px;
	transition: 150ms ease-in-out;
	border: 1px solid rgba(0, 0, 0, 0.2);
	border-radius: 6px;
	background-color: #fff;

	font-size: 14px;
	color: #111827;
	cursor: pointer;

	&:hover {
		border-color: rgba(0, 0, 0, 0.4);
	}

	&:focus {
		border-color: #2563eb; /* azul al foco */
		box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
		outline: none;
	}

	&::placeholder {
		color: #9ca3af;
	}
`;

export const Filters = styled("div")`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	position: relative;
	z-index: 100;
	gap: 5px;
`;
